import * as z from 'zod';

export const GetAdsTxtRequest = z.object({
  options: z
    .object({
      subdomain: z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .optional(),
    })
    .optional(),
});
export const GetAdsTxtResponse = z.object({
  adsTxt: z
    .object({
      content: z
        .string()
        .describe('Content of Ads.txt.')
        .max(720000)
        .optional(),
      default: z
        .boolean()
        .describe("Whether current Ads.txt is Wix's default.")
        .optional(),
      subdomain: z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .max(63)
        .optional(),
    })
    .describe('Ads txt object')
    .optional(),
});
export const UpdateAdsTxtRequest = z.object({
  options: z
    .object({
      adsTxt: z
        .object({
          content: z
            .string()
            .describe('Content of Ads.txt.')
            .max(720000)
            .optional(),
          default: z
            .boolean()
            .describe("Whether current Ads.txt is Wix's default.")
            .optional(),
          subdomain: z
            .string()
            .describe(
              'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
            )
            .max(63)
            .optional(),
        })
        .describe(
          "Submitted `adsTxT` object will replace the existing Ads.txt file.\nTo reset Ads.txt to Wix's default, submit `default:true` without a `content` object."
        )
        .optional(),
    })
    .optional(),
});
export const UpdateAdsTxtResponse = z.object({
  adsTxt: z
    .object({
      content: z
        .string()
        .describe('Content of Ads.txt.')
        .max(720000)
        .optional(),
      default: z
        .boolean()
        .describe("Whether current Ads.txt is Wix's default.")
        .optional(),
      subdomain: z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .max(63)
        .optional(),
    })
    .describe('Updated Ads txt object')
    .optional(),
});
export const AppendAdsTxtRequest = z.object({
  options: z
    .object({
      adsTxt: z
        .object({
          content: z
            .string()
            .describe('Content of Ads.txt.')
            .max(720000)
            .optional(),
          default: z
            .boolean()
            .describe("Whether current Ads.txt is Wix's default.")
            .optional(),
          subdomain: z
            .string()
            .describe(
              'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
            )
            .max(63)
            .optional(),
        })
        .describe(
          "Submitted `content` object will be appended to the existing Ads.txt file.\nTo reset Ads.txt to Wix's default, submit `default:true` without a `content` object."
        )
        .optional(),
    })
    .optional(),
});
export const AppendAdsTxtResponse = z.object({
  adsTxt: z
    .object({
      content: z
        .string()
        .describe('Content of Ads.txt.')
        .max(720000)
        .optional(),
      default: z
        .boolean()
        .describe("Whether current Ads.txt is Wix's default.")
        .optional(),
      subdomain: z
        .string()
        .describe(
          'Subdomain of Ads.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .max(63)
        .optional(),
    })
    .describe('Appended Ads.txt file.')
    .optional(),
});
